// extracted by mini-css-extract-plugin
export default {"table":"Reviews_table__6dAE3","icons":"Reviews_icons__y2hpw","pending":"Reviews_pending__iOCr+","delivered":"Reviews_delivered__cLweC"};